import main from './main.route'
import dashboard from './dashboard.route'
import communication from './communication.route'
import journal from './journal.route'
import financial from './financial.route'
import learning from './learning.route'
import members from './members.route'
import payments from './payments.route'
import children from './children.route'
import students from './students.route'
import settings from './settings.route'
import notifications from './notifications.route'
import acknowledgment from './acknowledgment.route'
export const modules = [
  main,
  dashboard,
  ...communication,
  journal,
  financial,
  learning,
  students,
  ...children,
  ...members,
  payments,
  ...settings,
  notifications,
  acknowledgment,
]
